import giftedReviewNotice from '@/components/gifted-review-notice/index.vue'

export default {
  name: 'ReviewsProfessional',
  components: {
    giftedReviewNotice
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
